import { isEmpty } from './methods';

export const mapToPayload = (data, mapper, isDraft = false) => {
  if (data === null || typeof data !== 'object') {
    return;
  }

  if (Array.isArray(data)) {
    return data.map((item) => mapToPayload(item, mapper, isDraft));
  }

  return Object.entries(mapper).reduce((acc, [key, mapFn]) => {
    const value = mapFn(data[key], isDraft);

    if (!isEmpty(value)) {
      acc[key] = value;
    }

    return acc;
  }, {});
};
